<section class="p-2 p-md-4">
  <div class="card mb-4">
    <div class="table-responsive">
      <div class="card-body row">
        <div class="col-12 col-lg-1 p-2">
          <div class="text-truncate">ID</div>
          <div class="form-control disabled bg-light border-grey text-center">{{ id }}</div>
        </div>
        <div class="col-12 col-lg-6 p-2">
          <div class="text-truncate">Consulta</div>
          <div class="form-control disabled bg-light border-grey">{{ consulta }}</div>
        </div>
        <div class="col-12 col-lg-5 p-2">
          <div class="text-truncate">Fornecedor</div>
          <div class="form-control disabled bg-light border-grey">{{ fornecedor }}</div>
        </div>
      </div>
      <div class="card-header bg-white">
        <h3>Adicionar nova entrada</h3>
      </div>
      <div class="card-body row">
        <div class="col-12 col-lg-4 p-2">
          <div class="text-truncate">DCS</div>
          <select class="form-control input-validate" name="dcs" id="dcs" [formControl]="form.controls.dcs">
            <option value="">Selecione</option>
            <option *ngFor="let d of listaDadoSaida" [value]="d.id">{{ d.nome | uppercase}}</option>
          </select>
          <app-msg-erro [control]="form.controls.dcs"></app-msg-erro>
        </div>
        <div class="col-12 col-lg-4 p-2">
          <div class="text-truncate">Tipo da consulta</div>
          <select class="form-control input-validate" name="tipoconsulta" id="tipoconsulta" [formControl]="form.controls.tipoConsulta">
            <option value="">Selecione</option>
            <option *ngFor="let tc of listaTipoConsulta" [value]="tc.id">{{ tc.nometipocampoconsulta | uppercase}}</option>
          </select>
          <app-msg-erro [control]="form.controls.tipoConsulta"></app-msg-erro>
        </div>
        <div class="col-12 col-lg-4 p-2">
          <div class="text-truncate">Conversão</div>
          <select class="form-control input-validate" name="conversao" id="conversao" [formControl]="form.controls.conversao">
            <option value="">Selecione</option>
            <option *ngFor="let c of listaConversao" [value]="c.id">{{ c.nome | uppercase}}</option>
          </select>
          <app-msg-erro [control]="form.controls.conversao"></app-msg-erro>
        </div>
        <div class="col-12 col-lg-4 p-2">
          <div class="text-truncate">Nome</div>
          <input type="text" class="form-control input-validate" name="nome" id="nome" [formControl]="form.controls.nome">
        </div>
        <div class="col-12 col-lg-4 p-2">
          <div class="text-truncate">Formato de entrada</div>
          <input type="text" class="form-control input-validate" name="formatoEntrada" id="formatoEntrada" [formControl]="form.controls.formatEntrada">
        </div>
        <div class="col-12 col-lg-4 p-2">
          <div class="text-truncate">Formato de saída</div>
          <input type="text" class="form-control input-validate" name="formatoSaida" id="formatoSaida" [formControl]="form.controls.formatSaida">
        </div>
        <div class="col-12 col-lg-6 p-2">
          <div class="text-truncate">Regex</div>
          <input type="text" class="form-control input-validate" name="regex" id="regex" [formControl]="form.controls.regex">
        </div>
        <div class="col-12 col-lg-6 p-2">
          <div class="text-truncate">Caminho</div>
          <input type="text" class="form-control input-validate" name="caminho" id="caminho" [formControl]="form.controls.caminho">
        </div>
        <div class="col-12 col-lg-6 p-2">
          <div class="text-truncate">Valor padrão</div>
          <input type="text" class="form-control input-validate" name="valorPadrao" id="valorPadrao" [formControl]="form.controls.valorPadrao">
        </div>
        <div class="col-12 col-lg-6 p-2">
          <div class="text-truncate">Consulta entrada Pai</div>
          <select class="form-control input-validate" name="dadosConsultaEntradaPai" id="dadosConsultaEntradaPai" [formControl]="form.controls.dadosConsultaEntradaPai">
            <option value="">Selecione</option>
            <option *ngFor="let c of listaDadosConsultaPai" [value]="c.id">{{ c.nome | uppercase}}</option>
          </select>
          <app-msg-erro [control]="form.controls.dadosConsultaEntradaPai"></app-msg-erro>
        </div>
        <div class="col-12 col-lg-12 p-2">
          <div class="text-truncate">Descrição</div>
          <textarea class="form-control input-validate" name="descricao" id="descricao" cols="4" rows="4" [formControl]="form.controls.descricao"></textarea>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-end card-footer bg-white text-muted mx-xl-2">
      <button class="btn btn-lg px-5 btn-success" [disabled]="form.invalid" (click)="submitForm()">
        <span>Salvar</span>
      </button>
    </div>
  </div>
</section>

<section class="p-2 p-md-4">
  <app-historico-dce [id]="id"></app-historico-dce>
</section>